import type { CasesTableFilter } from "@/components/Table/MrtCaseTable.tsx";
import { useFetchCaseTypes } from "@/queries/useFetchCaseTypes.ts";
import { CircularProgress, MenuItem, Paper, Typography } from "@mui/material";
import { RhfTextField } from "mui-rhf-integration";
import type { UseFormReturn } from "react-hook-form";

type Props = {
    form: UseFormReturn<CasesTableFilter>;
};

const CaseTypesForCasesTable = ({ form }: Props) => {
    const { data, isError, isRefetching, isLoading } = useFetchCaseTypes();

    if (isError) {
        return (
            <Paper
                sx={{
                    p: 2,
                    borderRadius: "8px",
                }}
            >
                <Typography variant={"h5"}>Error loading case types</Typography>
            </Paper>
        );
    }

    if (isLoading || isRefetching) {
        return (
            <Paper
                sx={{
                    p: 2,
                    borderRadius: "8px",
                }}
            >
                <CircularProgress size={"12px"} />
            </Paper>
        );
    }

    return (
        <RhfTextField
            select
            control={form.control}
            name={"caseType"}
            label={"Case Type"}
            sx={{
                width: "100%",
                backgroundColor: "#fff",
            }}
        >
            <MenuItem component={"li"} key={"case-type-blank"} value={""}>
                All
            </MenuItem>
            {data?.data.map((caseType) => (
                <MenuItem key={`case-type-${caseType.idUUID}`} value={`${caseType.caseType}`}>
                    {caseType.caseType}
                </MenuItem>
            ))}
        </RhfTextField>
    );
};

export default CaseTypesForCasesTable;
